/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Same_NoneInputs */

const en_us2_profile_editors_same_none = /** @type {(inputs: Profile_Editors_Same_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No, they change every week`)
};

const pt_br2_profile_editors_same_none = /** @type {(inputs: Profile_Editors_Same_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não, mudam toda semana`)
};

const es_419_profile_editors_same_none = /** @type {(inputs: Profile_Editors_Same_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No, cambian cada semana`)
};

const pt_pt2_profile_editors_same_none = /** @type {(inputs: Profile_Editors_Same_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não, mudam todas as semanas`)
};

const fr_fr2_profile_editors_same_none = /** @type {(inputs: Profile_Editors_Same_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non, ils changent chaque semaine`)
};

const de_de2_profile_editors_same_none = /** @type {(inputs: Profile_Editors_Same_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein, sie ändern sich jede Woche`)
};

const it_it2_profile_editors_same_none = /** @type {(inputs: Profile_Editors_Same_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No, cambiano ogni settimana`)
};

/**
* | output |
* | --- |
* | "No, they change every week" |
*
* @param {Profile_Editors_Same_NoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_same_none = /** @type {((inputs?: Profile_Editors_Same_NoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Same_NoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_same_none(inputs)
	if (locale === "es-419") return es_419_profile_editors_same_none(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_same_none(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_same_none(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_same_none(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_same_none(inputs)
	return en_us2_profile_editors_same_none(inputs)
});
export { profile_editors_same_none as "profile-editors.same_none" }